import kr from './locales/kr'
import jp from './locales/jp'

export default {
    kr,
    jp
}



// WEBPACK FOOTER //
// ./src/translations/index.js